module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.c07e4ea2.woff";